/* Mirinae Rich Text Editor System Styles */
@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200');

/* Floating Toolbar */
.mirinae-floating-toolbar {
    position: fixed;
    /* [FIX] Changed from absolute to fixed to handle scrolling/modal contexts better */
    z-index: 20000;
    /* High Z-Index to overlap Modals/Drawers */
    background-color: #1f2937;
    /* Gray 800 */
    border: 1px solid #374151;
    /* Gray 700 */
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    padding: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: opacity 0.2s, transform 0.2s;
    pointer-events: auto;
    opacity: 0;
    transform: translateY(10px);
    visibility: hidden;
}

.mirinae-floating-toolbar.visible {
    opacity: 1;
    transform: translateY(0);
    visibility: visible;
}

.mirinae-floating-toolbar.hidden {
    display: none;
}

.mirinae-toolbar-actions {
    display: flex;
    align-items: center;
    gap: 4px;
}

.mirinae-tool-btn {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: #e5e7eb;
    /* Gray 200 */
    background: transparent;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s;
}

.mirinae-tool-btn:hover {
    background-color: #374151;
    /* Gray 700 */
    color: #fff;
}

.mirinae-tool-btn span {
    font-size: 20px;
}

.mirinae-tool-separator {
    width: 1px;
    height: 20px;
    background-color: #4b5563;
    /* Gray 600 */
    margin: 0 4px;
}

.mirinae-toolbar-arrow {
    width: 10px;
    height: 10px;
    background-color: #1f2937;
    /* Gray 800 */
    transform: rotate(45deg);
    margin-top: -5px;
    border-bottom: 1px solid #374151;
    border-right: 1px solid #374151;
    z-index: -1;
}

/* Quote Styling */
/* Quote Styling - Scoped to Reader Body to prevent overlap */
#reader-body .type-dialogue,
.type-dialogue {
    margin-left: 0.5rem;
    padding-left: 1rem;
    border-left: 3px solid #818cf8;
    /* Indigo-400 */
    /* color: #fff; [FIX] Inherit from parent (Theme Aware) */
    color: inherit;
    font-weight: 700;
}

/* [FIX] 2026-02-15 Force Editor Font Consistency */
/* Ensure copied text doesn't show up with weird sizes in the editor */
#active-content * {
    font-size: inherit !important;
    line-height: inherit !important;
}